// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M3 9.2V2.99C3 2.17 3.67 1.5 4.49 1.5H6.5C7.2 1.5 7.87 1.61 8.5 1.81C10.64 2.5 12.3 4.28 12.83 6.5C12.94 6.98 13 7.48 13 8V12.5C13 13.6 12.1 14.5 11 14.5H8.6M8.5 1.81V4.5C8.5 5.6 9.39 6.5 10.5 6.5H12.83',
  'M5.8 4.5V5.25M5.8 7.7V8.45M5.8 10.7V11.35',
  'M7.3 12.85C7.3 13.68 6.63 14.35 5.8 14.35C4.97 14.35 4.3 13.68 4.3 12.85C4.3 12.02 4.97 11.35 5.8 11.35C6.63 11.35 7.3 12.02 7.3 12.85Z',
];
